var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerpetualLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3405_264)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4854 11.2076C22.1337 8.61341 26.3704 8.6134 29.0187 11.2076L35.2883 17.3493C38.015 20.0203 38.015 24.4102 35.2883 27.0812L24.3619 37.7847L32.1981 45.461C33.6911 46.9235 33.7158 49.3194 32.2533 50.8124C30.7907 52.3054 28.3948 52.3301 26.9018 50.8676L7.91783 32.271C5.19118 29.6 5.19118 25.2102 7.91783 22.5392L19.4854 11.2076ZM18.9541 32.4873L29.4401 22.2153L24.252 17.1331L13.766 27.4051L18.9541 32.4873Z",
    fill: "#3CEAAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3792 16.3974C38.0275 13.8032 42.2642 13.8032 44.9125 16.3974L51.1821 22.5391C53.9088 25.2101 53.9088 29.6 51.1821 32.271L32.1981 50.8676C30.7051 52.3301 28.3092 52.3054 26.8467 50.8124C25.3841 49.3194 25.4088 46.9235 26.9018 45.461L34.7381 37.7847L29.1095 32.271C26.3829 29.6 26.3829 25.2101 29.1095 22.5391L35.3792 16.3974ZM40.1458 32.4873L45.3339 27.405L40.1458 22.3228L34.9577 27.405L40.1458 32.4873Z",
    fill: "#03BCE4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M34.9547 27.4179L29.4435 22.1832L24.1574 27.3747L29.5378 32.7274L34.9547 27.4179Z",
    fill: "#00A4E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3405_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerpetualLogo);
export default __webpack_public_path__ + "static/media/perpetual-logo.79d7f26016c2b931d77cf74537a18478.svg";
export { ForwardRef as ReactComponent };